/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { ERC20WithFee } from "../ERC20WithFee";

export class ERC20WithFee__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<ERC20WithFee> {
    return super.deploy(overrides || {}) as Promise<ERC20WithFee>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): ERC20WithFee {
    return super.attach(address) as ERC20WithFee;
  }
  connect(signer: Signer): ERC20WithFee__factory {
    return super.connect(signer) as ERC20WithFee__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): ERC20WithFee {
    return new Contract(address, _abi, signerOrProvider) as ERC20WithFee;
  }
}

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "FeePaid",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "feeRate",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "mint",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "sender",
        type: "address",
      },
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x608060405234801561001057600080fd5b50610a8b806100206000396000f3fe608060405234801561001057600080fd5b50600436106100cf5760003560e01c806340c10f191161008c578063978bbdb911610066578063978bbdb914610190578063a457c2d714610199578063a9059cbb146101ac578063dd62ed3e146101bf576100cf565b806340c10f191461016257806370a082311461017557806395d89b4114610188576100cf565b806306fdde03146100d4578063095ea7b3146100f257806318160ddd1461011557806323b872dd14610127578063313ce5671461013a578063395093511461014f575b600080fd5b6100dc6101f8565b6040516100e99190610943565b60405180910390f35b61010561010036600461091a565b61028a565b60405190151581526020016100e9565b6003545b6040519081526020016100e9565b6101056101353660046108df565b6102a0565b60065460405160ff90911681526020016100e9565b61010561015d36600461091a565b6102f2565b61010561017036600461091a565b610329565b610119610183366004610893565b610335565b6100dc610354565b61011960005481565b6101056101a736600461091a565b610363565b6101056101ba36600461091a565b61039a565b6101196101cd3660046108ad565b6001600160a01b03918216600090815260026020908152604080832093909416825291909152205490565b60606004805461020790610a04565b80601f016020809104026020016040519081016040528092919081815260200182805461023390610a04565b80156102805780601f1061025557610100808354040283529160200191610280565b820191906000526020600020905b81548152906001019060200180831161026357829003601f168201915b5050505050905090565b60006102973384846103a7565b50600192915050565b60006102ad8484846104d0565b6001600160a01b0384166000908152600260209081526040808320338085529252909120546102e89186916102e39086906109ed565b6103a7565b5060019392505050565b3360008181526002602090815260408083206001600160a01b038716845290915281205490916102979185906102e3908690610996565b60006102978383610676565b6001600160a01b0381166000908152600160205260409020545b919050565b60606005805461020790610a04565b3360008181526002602090815260408083206001600160a01b038716845290915281205490916102979185906102e39086906109ed565b60006102973384846104d0565b6001600160a01b03831661040e5760405162461bcd60e51b8152602060048201526024808201527f45524332303a20617070726f76652066726f6d20746865207a65726f206164646044820152637265737360e01b60648201526084015b60405180910390fd5b6001600160a01b03821661046f5760405162461bcd60e51b815260206004820152602260248201527f45524332303a20617070726f766520746f20746865207a65726f206164647265604482015261737360f01b6064820152608401610405565b6001600160a01b0383811660008181526002602090815260408083209487168084529482529182902085905590518481527f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b925910160405180910390a3505050565b6001600160a01b0383166105345760405162461bcd60e51b815260206004820152602560248201527f45524332303a207472616e736665722066726f6d20746865207a65726f206164604482015264647265737360d81b6064820152608401610405565b6001600160a01b0382166105965760405162461bcd60e51b815260206004820152602360248201527f45524332303a207472616e7366657220746f20746865207a65726f206164647260448201526265737360e81b6064820152608401610405565b600080546105a590839061075e565b905060006105b382846109ed565b90506105bf858361077a565b6001600160a01b0385166000908152600160205260409020546105e39082906109ed565b6001600160a01b038087166000908152600160205260408082209390935590861681522054610613908290610996565b6001600160a01b0380861660008181526001602052604090819020939093559151908716907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef906106679085815260200190565b60405180910390a35050505050565b6001600160a01b0382166106cc5760405162461bcd60e51b815260206004820152601f60248201527f45524332303a206d696e7420746f20746865207a65726f2061646472657373006044820152606401610405565b806003546106da9190610996565b6003556001600160a01b038216600090815260016020526040902054610701908290610996565b6001600160a01b0383166000818152600160205260408082209390935591519091907fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef906107529085815260200190565b60405180910390a35050565b60006107738383670de0b6b3a764000061085d565b9392505050565b6001600160a01b0382166107da5760405162461bcd60e51b815260206004820152602160248201527f45524332303a206275726e2066726f6d20746865207a65726f206164647265736044820152607360f81b6064820152608401610405565b806003546107e891906109ed565b6003556001600160a01b03821660009081526001602052604090205461080f9082906109ed565b6001600160a01b0383166000818152600160205260408082209390935591517fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef906107529085815260200190565b60008161086a84866109ce565b61087491906109ae565b949350505050565b80356001600160a01b038116811461034f57600080fd5b6000602082840312156108a4578081fd5b6107738261087c565b600080604083850312156108bf578081fd5b6108c88361087c565b91506108d66020840161087c565b90509250929050565b6000806000606084860312156108f3578081fd5b6108fc8461087c565b925061090a6020850161087c565b9150604084013590509250925092565b6000806040838503121561092c578182fd5b6109358361087c565b946020939093013593505050565b6000602080835283518082850152825b8181101561096f57858101830151858201604001528201610953565b818111156109805783604083870101525b50601f01601f1916929092016040019392505050565b600082198211156109a9576109a9610a3f565b500190565b6000826109c957634e487b7160e01b81526012600452602481fd5b500490565b60008160001904831182151516156109e8576109e8610a3f565b500290565b6000828210156109ff576109ff610a3f565b500390565b600281046001821680610a1857607f821691505b60208210811415610a3957634e487b7160e01b600052602260045260246000fd5b50919050565b634e487b7160e01b600052601160045260246000fdfea26469706673582212203b2f744d064224401e51e86f8fef0cb36705aba7672500cd6ebb68dfd38978cc64736f6c63430008020033";
